module.exports = __webpack_public_path__ + "static/media/companyLogoTopo.74115507.png";